import autoBind from "auto-bind";
import get from "lodash/get";
import Address from "../../common/models/address";
import {findRelation} from "../../api/utils";

class Shop {
  constructor(shopObject, settingsObject) {
    this.shopObject = shopObject;
    this.settingsObject = settingsObject;
    autoBind(this);
  }

  equals(otherShop) {
    if (!otherShop || !(otherShop instanceof Shop)) return false;

    return this.getId() === otherShop.getId();
  }

  getId() {
    return get(this.shopObject, "data.id");
  }

  getName() {
    return get(this.shopObject, "data.attributes.name");
  }

  getCoordinates() {
    return {
      lat: get(this.shopObject, "data.attributes.coordinates.lat"),
      lng: get(this.shopObject, "data.attributes.coordinates.lng"),
    };
  }

  getAddress() {
    return new Address(get(this.shopObject, "data.attributes.address"));
  }

  getCountry() {
    const address = this.getAddress();
    return address.country || "US";
  }

  getLicenseNumber() {
    return get(this.shopObject, "data.attributes.license_number");
  }

  getMenuUrl() {
    const site = this.getSite();
    if (!site) return null;

    return site.url;
  }

  getSite() {
    const siteRelation = get(this.shopObject, "data.relationships.site.data");
    if (siteRelation) {
      const site = findRelation(this.shopObject.included, siteRelation);
      return get(site, "attributes");
    } else {
      return null;
    }
  }

  getGroup() {
    const siteRelation = get(this.shopObject, "data.relationships.group.data");
    if (siteRelation) {
      const group = findRelation(this.shopObject.included, siteRelation);
      return get(group, "attributes");
    } else {
      return null;
    }
  }

  getMenuPath() {
    const menuUrl = this.getMenuUrl();
    if (!menuUrl) return null;

    return new URL(menuUrl).pathname;
  }

  getSlug() {
    const path = this.getMenuPath();
    if (!path) return null;

    if (this.getSite().basepath) {
      return path.replace(this.getSite().basepath, "").replace(/\//g, "");
    } else {
      return path.replace("/", "");
    }
  }

  getThumbnail() {
    return this.shopObject?.data?.attributes?.thumbnail;
  }

  isPickupAllowed() {
    return this.settingsObject?.data?.attributes?.allow_pickup || false;
  }

  isDeliveriesAllowed() {
    return this.settingsObject?.data?.attributes?.allow_deliveries || false;
  }

  getGroupName() {
    const group = this.getGroup();
    if (!group) return null;
    return group.name;
  }
}

export default Shop;
